import { HTMLAttributes } from 'react'
import {
  DisplayProps,
  LayoutProps,
  MarginProps,
  PositionProps,
} from 'styled-system'

import { TestIdProps } from 'designSystem/types/propTypes'

import INTERNALxTag from 'designSystem/components/internal/INTERNALxTag'

type TagSize = 'sm' | 'md' | 'lg'
type TagVariant = 'alert' | 'info' | 'neutral' | 'success' | 'warning'

type BaseProps = HTMLAttributes<HTMLSpanElement> &
  DisplayProps &
  LayoutProps &
  MarginProps &
  PositionProps &
  TestIdProps

type Props = {
  size?: TagSize
  showBorder?: boolean
  symbol?: string
  variant?: TagVariant
} & BaseProps

export default function PDSAssetTag({
  size = 'md',
  showBorder = true,
  symbol,
  testId,
  variant = 'neutral',
  ...props
}: Props) {
  const sizeStyles = ASSET_TAG_HEIGHT[size] ?? ASSET_TAG_HEIGHT.md

  return (
    <INTERNALxTag
      {...props}
      display="flex"
      justifyContent="center"
      showBorder={showBorder}
      size={size}
      testId={testId}
      variant={variant}
      {...sizeStyles}
    >
      {symbol}
    </INTERNALxTag>
  )
}

type AssetTagSizeStyles = {
  height: string
  minWidth: string
}
const ASSET_TAG_HEIGHT: { [key: string]: AssetTagSizeStyles } = {
  sm: {
    height: '1.25rem',
    minWidth: '3.75rem',
  },
  md: {
    height: '1.375rem',
    minWidth: '3.75rem',
  },
  lg: {
    height: '1.5rem',
    minWidth: '4.5rem',
  },
}
